import React, {useMemo, useCallback} from 'react';
import cx from './index.module.scss';
import {getTextChartColumns} from '../../assets/columns.data';
import {getBlindValueByYears} from '../../assets/years.data';
import About from '../About';
import CopyButton from '../CopyButton';
import { ReactComponent as IconInfoBlack } from '../../assets/images/icon_info_black.svg';

const TextChart = ({company, clickedYears, setModal}) => {
  const items = useMemo(() => {
    if (!company) return [];
    return getTextChartColumns().map((item, index) => ({
      ...item,
      value: company[index],
    }))
  }, [company]);

  const handleClick = useCallback(() => {
    setModal(<About />)
  }, [setModal]);

  return (
    <div className={cx.wrap}>
      <div className={cx.total}>
        <div className={cx.clickArea} onClick={handleClick}>
          <div className={cx.strong}>
            {company ? company.total : getBlindValueByYears(clickedYears)}
            <span className={cx.avgValue}>평균 <strong className={cx.num}>47</strong></span>
          </div>
          <div className={cx.valueText}>
            {company ? '블라인드 지수' : '평균 블라인드 지수'}<IconInfoBlack className={cx.iconInfo} />
          </div>
        </div>
        <CopyButton company={company} />
      </div>
      {!!items.length && (
        <div className={cx.list}>
          {items.map(item => (
            <div className={cx.item} key={`text-chart-item-${item.title}`}>
              <span>{item.title}</span>
              <strong className={cx.value}>{item.value}</strong>
              <span className={cx.avgValue}>평균 <strong className={cx.num}>{item.avgValue}</strong></span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
};

export default TextChart;
